<template>
  <div class="member__tools">
    <div class="title">学习工具</div>
    <div class="member__tools-item item1" @click="goStudy(1)">{{ isUnlock ? '已' : '' }}解锁长难句所有句子</div>
    <div class="member__tools-item item2" @click="goStudy(2)">{{ isUnlock ? '已' : '' }}解锁宇哥试题</div>
    <div class="member__tools-item item3" @click="goStudy(3)">{{ isUnlock ? '已获得' : '' }}{{ activeTab === 20 ? 20 :
      999 }}次批改机会{{ !isUnlock ? "，让写作无忧！" : '' }}</div>
  </div>
</template>

<script>
import { whatEev } from '@/utils/tools';
import wx from 'weixin-js-sdk';
import { miniSchemeUrl } from '@/utils/common';

export default {
  props: {
    activeTab: {
      type: Number,
      value: 20,
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {

    };
  },
  computed: {
    isUnlock() {
      const { level } = this.userMemberInfo;
      const { id } = this.userInfo;
      const flag = !id ? false : ((this.activeTab === 20 && [10, 20, 40, 50, 60].includes(level)) || (this.activeTab === 30 && level === 30));
      return !!flag;
    },
  },
  methods: {
    // 跳转页面
    goStudy(key) {
      const urlObj = {
        1: '/longSentences/list/list',
        2: '/zhangyuPractice/home/index',
        3: '/correction/home/index',
      };
      if (whatEev() === 'miniprogram') {
        wx.miniProgram.navigateTo({
          url: urlObj[key],
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: urlObj[key],
        });
      } else {
        this.getSchemeUrl(urlObj[key]);
      }
    },
    // h5 打开小程序的方法
    async getSchemeUrl(path) {
      const schemeLink= await  miniSchemeUrl('wxdb89cfa2bb60f779',path)
      window.location.href=schemeLink;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../index.scss';

.member__tools {
  width: 678px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto 36px;
}

.title {
  width: 100%;
  margin-bottom: 22px;
  height: 40px;
  font-size: 29px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 40px;
}

.member__tools-item {
  @include background(214px, 212px);
  padding: 134px 18px 0;

  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  line-height: 25px;
}

.item1 {
  @include backgroundImage('member_tools-11.png');
  color: #728D92;
}

.item2 {
  @include backgroundImage('member_tools-2.png');
  color: #72839C;
}

.item3 {
  @include backgroundImage('member_tools-3.png');
  color: #9A7977;
}
</style>
